export function placeTree(lookups) {
    const nenda = { kind: "company", id: lookups.nendaCompanyId };
    const company = (id) => id ? { kind: "company", id } : nenda;
    return {
        parentOf(place) {
            switch (place.kind) {
                case "unit": {
                    const premise = lookups.premiseOfUnit(place.id);
                    return premise ? { kind: "premise", id: premise } : nenda;
                }
                case "premise":
                    return company(lookups.companyOfPremise(place.id));
                case "company":
                    return place.id === nenda.id
                        ? null
                        : company(lookups.parentOfCompany(place.id));
            }
        },
    };
}
export function samePlace(a, b) {
    return a.kind === b.kind && a.id === b.id;
}
export function placeChain(place, tree) {
    const chain = [];
    let at = place;
    while (at) {
        const current = at;
        if (chain.some((p) => samePlace(p, current)))
            break;
        chain.push(current);
        at = tree.parentOf(current);
    }
    return chain;
}
export function isNenda(place, tree) {
    return place.kind === "company" && tree.parentOf(place) === null;
}
export function isBelow(lower, upper, tree) {
    return placeChain(lower, tree)
        .slice(1)
        .some((p) => samePlace(p, upper));
}
